import React from 'react'
import { Link } from 'react-router-dom'
import {
  Box,
  Typography
} from "@mui/material";
import BoltSharpIcon from '@mui/icons-material/BoltSharp';
export default function Navbar() {
  return (
    <>
        <div className="Navbar">
            <div className="header">
                <img src="/assets/images/logo_1.png" alt="icon_image" />
               <Box textAlign="center" sx={{ mb: {xs: "5px",sm: "4px",md: "32px",},mt:{xs: "5px",sm: "4px",md: "32px",}}}>
                    <Typography
                        variant="h2"
                        fontWeight="bold"
                        sx={{
                        display: "inline-block",
                        position: "relative",
                        background:
                            "linear-gradient(270deg, #be063dff, #d320b5ff, #8706f7ff, #f0f324ff)",
                        backgroundSize: "600% 600%",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        animation: "gradientMove 6s ease infinite",
                        pb: 1,
                         fontSize: {
                            xs: "1.3rem",   // ✅ mobile
                            sm: "2.3rem",   // tablet
                            md: "3rem",   // laptop
                            lg: "4.5em"    // desktop
                        },
                        }}
                    >
                        Maa Sharde Digital Seva Kendra
                    </Typography>
                        <br /><Typography sx={{color:"#2109f3ff"}}><i><BoltSharpIcon sx={{fontSize:{xs:"1rem"}}}/>सबसे तेज Update !</i></Typography>
                    {/* Keyframes */}
                    <style>
                        {`
                        @keyframes gradientMove {
                            0% { background-position: 0% 50%; }
                            50% { background-position: 100% 50%; }
                            100% { background-position: 0% 50%; }
                        }
                        `}
                    </style>
                </Box>
                
                <img src="/assets/images/logo_1.png" alt="icon_image" />
            </div>
            <div className="NavItem">
                <ul>
                    <li><Link to="/">Home</Link></li><span>|</span>
                    <li><Link to="/admission">Admission</Link></li><span>|</span>
                    <li><Link to="/result">Results</Link></li><span>|</span>
                    <li><Link to="/latestjob">Latest Job</Link></li><span>|</span>
                    <li><Link to="/answerkey">Answer Key</Link></li><span>|</span>
                    <li><Link to="/important">Important</Link></li><span>|</span>
                    <li><Link to="/contactuser">Contact Us</Link></li>
                </ul>
            </div>
        </div>
    </>
  )
}
